import * as React from 'react';

export const getClubProgrammePopoverStyle = (
  width: number,
  direction: 'down' | 'up' = 'down'
): React.CSSProperties => ({
  position: 'absolute',
  ...(direction === 'up' ? { bottom: 'calc(100% + 4px)' } : { top: 'calc(100% + 4px)' }),
  left: 0,
  zIndex: 60,
  background: '#fff',
  border: '1px solid #ced4da',
  borderRadius: 6,
  padding: 8,
  boxShadow: '0 10px 22px rgba(0,0,0,0.12)',
  width,
  maxWidth: '90vw'
});

export const clubProgrammeMenuStyle: React.CSSProperties = {
  position: 'absolute',
  top: 'calc(100% + 6px)',
  left: 0,
  zIndex: 70,
  background: '#fff',
  border: '1px solid #ced4da',
  borderRadius: 8,
  boxShadow: '0 10px 22px rgba(0,0,0,0.12)',
  padding: 6
};
